module.exports = __webpack_public_path__ + "static/media/11_l_server_0_11.67.15e70607.png";